import { FormControl, Select, SelectProps } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components/macro';
import { Except } from 'type-fest';
import { ErrorText } from '../misc';
import {
  SharedInputProps,
  sharedInputStyle,
} from './utilities/shared-input-style';

const StyledFormControl = styled(FormControl)<SharedInputProps>`
  ${sharedInputStyle}
`;

export type SelectInputProps = {
  errorText?: string;
  greyPlaceholder?: boolean;
  minHeight?: number;
} & Except<SelectProps, 'classes'>;

export default function SelectInput({
  errorText,
  greyPlaceholder,
  minHeight,
  className,
  ...props
}: SelectInputProps): JSX.Element {
  return (
    <StyledFormControl
      variant="outlined"
      $greyPlaceholder={greyPlaceholder}
      $noHelperText={!errorText}
      $minHeight={minHeight}
      error={!!errorText}
      {...{ className }}
    >
      <Select variant="outlined" {...props} />
      <ErrorText message={errorText} />
    </StyledFormControl>
  );
}
